// Module
var code = "<div class=\"order-history-panel\">\r\n    <div class=\"order-history-panel-container-top\">\r\n        <rangeSelectPanel name='orderHistoryRangeSelect' />\r\n    </div>\r\n\r\n    <div class=\"order-history-panel-container-table\">\r\n        <terceraPanel name='windowPanelBodyQT' />\r\n    </div>\r\n</div>";
// Exports
export default code;